<template>
  <v-container class="px-0 py-0">
    <v-form ref="extratoConsolidadoFilterForm">
      <v-row class="px-0 py-0">
        <v-col cols="12" sm="6" md="2">
          <label>Tipo de data</label>
          <v-select
            v-model="formData.tipo_data"
            :items="[
              { id: 'dt_faturamento', descricao: 'Cobrança' },
              { id: 'dt_prev_vencimento', descricao: 'Vencimento' }
            ]"
            item-value="id"
            item-text="descricao"
            :menu-props="{ bottom: true, offsetY: true }"
            flat
            solo
            dense
            outlined
          ></v-select>
        </v-col>
        <v-col cols="12" sm="6" md="2">
          <label>Data entre</label>
          <v-menu
            ref="dtI"
            :close-on-content-click="true"
            transition="scale-transition"
            offset-y
          >
          <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="dateIFormatted"
                    dense
                    v-mask="'##/##/####'"
                    format="DD/MM/YYYY"
                    placeholder="DD/MM/YYYY"
                    label
                    outlined
                    v-bind="attrs"
                    v-on="on"
                    append-icon="mdi-calendar-blank"
                    @blur="dateI = parseDate(dateIFormatted)"
                    :rules="[formRules.requiredField, formRules.typeDateFormated]"
                ></v-text-field>
                </template>
            <v-date-picker
              color="primary"
              v-model="dateI"
              no-title
              scrollable
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" sm="6" md="2">
          <label>até</label>
          <v-menu
            ref="dtF"
            :close-on-content-click="true"
            transition="scale-transition"
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="dateFFormatted"
                v-mask="'##/##/####'"
                format="DD/MM/YYYY"
                placeholder="DD/MM/YYYY"
                label
                dense
                outlined
                v-bind="attrs"
                v-on="on"
                append-icon="mdi-calendar-blank"
                @blur="dateF = parseDate(dateFFormatted)"
                :rules="[formRules.requiredField, formRules.typeDateFormated]"
              ></v-text-field>
            </template>
            <v-date-picker
              color="primary"
              v-model="dateF"
              no-title
              scrollable
            ></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
      <v-row class="px-0 py-0">
        <v-col cols="12" sm="6" md="3" class="px-3 py-0">
          <label>Prestador</label>
          <v-autocomplete
            v-model="formData.prestador_id"
            :items="prestadoresFilter"
            item-value="id"
            item-text="prest_nome"
            label="Selecione"
            multiple
            chips
            outlined
            flat
            solo
            dense
            filled
            :disabled="prestadoresFilter.length == 1"
            :search-input.sync="searchInput"
          >
            <template v-slot:item="data">
              <v-list-item
                @click="toggleAutocomplete(data.item, 'prestador_id')"
                :class="
                  formData.prestador_id.includes(data.item.id)
                    ? 'primary--text v-list-item--active'
                    : ''
                "
              >
                <v-list-item-content>
                  <v-list-item-title>{{
                    data.item.prest_nome
                  }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <template v-slot:selection="data">
              <v-chip
                v-if="data.index < 2"
                small
                label
                class="ma-1"
                :style="
                  formData.prestador_id.length > 1
                    ? 'max-width:30%'
                    : 'max-width:100%'
                "
                >{{ data.item.prest_nome }}</v-chip
              >
              <span v-if="data.index == 2" class="ml-2 grey--text caption">
                (+{{
                  formData.prestador_id.length == 3
                    ? formData.prestador_id.length - 2 + " outro"
                    : formData.prestador_id.length - 2 + " outros"
                }})
              </span>
            </template>
          </v-autocomplete>
        </v-col>
        <v-col cols="12" sm="6" md="3" class="px-3 py-0">
          <label>Operadoras</label>
          <v-autocomplete
            v-model="formData.operadora_ans_id"
            :items="operadorasFilter"
            item-value="id"
            item-text="oper_nome"
            label="Selecione"
            multiple
            chips
            outlined
            flat
            solo
            dense
            filled
            :search-input.sync="searchInput"
          >
            <template v-slot:item="data">
              <v-list-item
                @click="toggleAutocomplete(data.item, 'operadora_ans_id')"
                :class="
                  formData.operadora_ans_id.includes(data.item.id)
                    ? 'primary--text v-list-item--active'
                    : ''
                "
              >
                <v-list-item-content>
                  <v-list-item-title>{{
                    data.item.oper_nome
                  }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <template v-slot:selection="data">
              <v-chip
                v-if="data.index < 2"
                small
                label
                class="ma-1"
                :style="
                  formData.operadora_ans_id.length > 1
                    ? 'max-width:30%'
                    : 'max-width:100%'
                "
                >{{ data.item.oper_nome }}</v-chip
              >
              <span v-if="data.index == 2" class="ml-2 grey--text caption">
                (+{{
                  formData.operadora_ans_id.length == 3
                    ? formData.operadora_ans_id.length - 2 + " outro"
                    : formData.operadora_ans_id.length - 2 + " outros"
                }})
              </span>
            </template>
          </v-autocomplete>
        </v-col>
        <v-col class="py-0">
          <v-btn
            class="mt-5"
            height="31px"
            small
            depressed
            color="primary"
            @click="sendFilter(true)"
            >Filtrar</v-btn
          >
          <v-btn
            class="mt-5 ml-4"
            height="31px"
            small
            depressed
            outlined
            color="primary"
            @click="clearFilters()"
            >Limpar Filtros</v-btn
          >
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
// import moment from "moment";
import { mask } from "vue-the-mask";
import { mapState } from "vuex";
export default {
  directives: {
    mask,
  },
  data() {
    return {
      prest: null,
      formData: {
        data_fim: null,
        data_inicio: null,
        modulo_operadora: "recebiveis",
        operadora_ans_id: [],
        prestador_id: [],
        tipo_data: "dt_faturamento",
      },
      dateF:null,
      dateFFormatted: null,
      dateI:null,
      dateIFormatted: null,
      dtI: false,
      dtF: false,
      prestadoresFilter: [],
      operadorasFilter: [],
      responsaveisFilter: [],
      searchInput: null
    };
  },
  computed: {
    ...mapState({
      formRules: (state) => state.formRules,
    }),
  },
  methods: {
    clearFilters() {
      this.dateFFormatted = null;
      this.dateIFormatted = null;
      this.formData.data_fim = null;
      this.formData.data_inicio = null;
      this.formData.operadora_ans_id = [];
      if (this.prestadoresFilter.length > 1) {
        this.formData.prestador_id = [];
      }
      // this.updateFilter(this.formData, false);
    },
    changePrestador() {
      this.formData.operadora_ans_id = [];
      let {modulo_operadora, prestador_id} = this.formData
      this.getOperadoras({
        modulo_operadora,
        prestador_ids: prestador_id
      });
    },
    sendFilter(gerarGrafico) {
      if (this.$refs.extratoConsolidadoFilterForm.validate()) {
        if ( !this.formData.data_fim && this.formData.data_inicio ) {
          this.dateF = this.formData.data_inicio;
          this.formData.data_fim = this.formData.data_inicio;
        } else if( !this.formData.data_inicio && this.formData.data_fim ){
          this.dateI = this.formData.data_fim;
          this.formData.data_inicio = this.formData.data_fim;
        }
        if(gerarGrafico){
          this.updateFilter(this.formData);
        } else {
          this.solicitaRelatorio(this.formData);
        }
      }
    },
    toggleAutocomplete(item, campo) {
      this.searchInput = null
      let index = this.formData[campo].indexOf(item.id);
      //  index > -1  está excluindo o item
      if (index > -1) {
        this.formData[campo].splice(index, 1);
      } else {
        //  index < 0  está adicionando o item
        this.formData[campo].push(item.id);
      }
      this.$nextTick();
      return;
    },
  },
  props: {
    filter: Object,
    formatDate: Function,
    updateFilter: Function,
    getOperadoras: Function,
    operadoras: Array,
    parseDate: Function,
    prestadores: Array,
    solicitaRelatorio: Function,
    validarForm: Boolean,
  },
  mounted() {
    this.prestadoresFilter = Array.from(this.prestadores);
    if (this.prestadoresFilter.length == 1) {
      this.formData.prestador_id = [this.prestadores[0].id];
    }
  },
  watch: {
    dateF(val){
          if (!val) {
            this.dateFFormatted = null
          } else {
            if (!!this.dateI && Date.parse(this.dateI) > Date.parse(val)){
              this.dateI = val
            }
            this.dateFFormatted = this.formatDate(val)
          }
        },
        dateFFormatted(val){
          this.formData.data_fim = this.parseDate(val)
        },
    // dateFFormatted(val) {
    //   if (!val) {
    //     this.formData.data_fim = null;
    //   } else {
    //     if (
    //       !!this.formData.data_inicio &&
    //       Date.parse(this.formData.data_inicio) >
    //         Date.parse(this.parseDate(val))
    //     ) {
    //       this.dateIFormatted = val;
    //       this.formData.data_inicio = this.parseDate(val);
    //     }
    //     this.formData.data_fim = this.parseDate(val);
    //   }
    // },
    dateI(val){
      if (!val) {
        this.dateIFormatted = null
      } else {
        if (!!this.dateF && Date.parse(this.dateF) < Date.parse(val)){
          this.dateF = val
        }
        this.dateIFormatted = this.formatDate(val)
      }
    },
    dateIFormatted(val){
          this.formData.data_inicio = this.parseDate(val)
        },
    // dateIFormatted(val) {
    //   if (!val) {
    //     this.formData.data_inicio = null;
    //   } else {
    //     if (
    //       !!this.formData.data_fim &&
    //       Date.parse(this.formData.data_fim) <
    //         Date.parse(this.parseDate(val))
    //     ) {
    //       this.dateFFormatted = val;
    //       this.formData.data_fim = this.parseDate(val);
    //     }
    //     this.formData.data_inicio = this.parseDate(val);
    //   }
    // },
    operadoras: {
      deep: true,
      handler(val) {
        this.operadorasFilter = Array.from(val);
        if (val && val.length == 1) {
          this.formData.operadora_ans_id = [val[0].id];
        }
      },
    },
    prestadores: {
      deep: true,
      handler(val) {
        this.prestadoresFilter = Array.from(val);
        if (val && val.length == 1) {
          this.formData.prestador_id = [val[0].id];
        }
      },
    },
    validarForm: {
      handler(val) {
        if (val) {
          this.sendFilter(false);
        }
      },
    },
  },
};
</script>
